/** Подсказки для status-chip (hover). */
export const CHIP_HINTS = {
  rtt: "RTT ICE candidate-pair на recvTransport (SFU → UI). Спарк справа от подписи — последние 5 сэмплов (высота = RTT). ≤120 хорошо, ≤250 норм, ≤800 деград, ≤2000 плохо, >2000 критично.",
  loss: "Доля потерь RTP за ~2 с на downlink (худшая камера). Спарк — история Loss. ≤2% хорошо, ≤5% норм, ≤10% деград, ≤20% плохо, >20% критично.",
  battery: "battery_percent из telemetry.robot_status (DataChannel telemetry).",
  mode: "mode из telemetry.robot_status (drive, estop, fault, …).",
  cameras: "Камеры с активным видеопотоком (синхронизировано между операторами).",
  signaling:
    "WebRTC recvTransport (ICE/DTLS), не protoo WebSocket. failed/disconnected = медиа-путь, не signaling WS.",
  config: "robot-config (limits) с streamer через DataChannel telemetry.",
  socketio:
    "Свежесть телеметрии: OK если пакет event: telemetry был <3 с назад. Влияет на блок «Текущая скорость».",
  uplinkRtt: "ICE/RTCP RTT на SendTransport робота (robot → SFU). Спарк — история RTT (5 сэмплов).",
  uplinkLoss:
    "Доля потерь RTP за интервал на uplink. Спарк — история Loss. Пороги: ≤2 / ≤5 / ≤10 / ≤20%.",
  uplinkTransport: "Состояние SendTransport робота (connected / failed / …).",
  abrProfile:
    "Реакция энкодера (zed-xonegs-driver): профиль · fps · bitrate. Меняется по качеству канала (Loss/RTT), это не отдельная метрика сети.",
} as const;
